<template>
  <main>
    <header class="container content-padding my-1">
      <router-link to="/" tag="a" class="navbar-brand">
        <img src="/static/img/main-logo.svg"
             class="logo"
             :style="$mq.phone ? 'padding: 0 1rem' : ''"
             height="38"
             alt="BeNeat - บริการจองแม่บ้านทำความสะอาดออนไลน์ คุณภาพเชื่อถือได้">
      </router-link>
    </header>
    <div class="container content-padding my-1">
      <div class="d-flex flex-sm-row flex-column justify-content-center justify-content-sm-center">
        <div class="mx-3 my-2" v-if="step === 1">
  
          <b-img-lazy src="https://beneat.s3.ap-southeast-1.amazonaws.com/marketing_campaigns/agency-professional-register-promotion.png" :class="$mq.phone ? 'img-fluid' : 'img-default-size'" alt=""></b-img-lazy>
          <!-- <b-skeleton-img></b-skeleton-img> -->
        </div>
        <div class="mx-3 my-2" ref="formInput">
          <b-form @submit.prevent="onSubmit" data-vv-scope="form-register-byagen">
            <template v-if="step == 1">
              <label> กรุณากรอกแบบฟอร์มการสมัคร</label>
              <b-form-input
                class="my-3"
                id="input-name"
                v-model="form.full_name"
                type="text"
                placeholder="ชื่อ นามสกุล"
                required
              ></b-form-input>
              <b-form-input
                class="mt-3 mb-2"
                id="input-phone"
                type="text"
                placeholder="เบอร์โทร (กรอกเฉพาะตัวเลขและพิมพ์ติดกัน)"
                v-model="form.phone"
                required
                :state="nameState"
                aria-describedby="input-live-feedback"
              ></b-form-input>
              <b-form-invalid-feedback id="input-live-feedback">
                กรุณากรอกเบอร์โทรศัพท์
              </b-form-invalid-feedback>

              <b-form-input
                class="mt-3 mb-2"
                id="input-email"
                type="text"
                placeholder="อีเมล์ (โปรดระบุ)"
                v-model="form.email"
                required
                :state="nameState"
                aria-describedby="input-live-feedback"
              ></b-form-input>
  
              <b-form-group class="mt-3">
                <label> จังหวัดและเขต/อำเภอ ที่สะดวกให้บริการ</label>
                <div class="row no-gutters">
                  <div class="col-6 mb-3 pr-1">
                    <label><span class="text-danger font-weight-bold">*</span> จังหวัด</label>
                    <b-form-select v-model="form.address_province_id" @change="changeAddressProvince(form.address_province_id)" :options="sortedProvinces" value-field="id" text-field="name_th" required></b-form-select>
                  </div>
                  <div class="col-6 mb-3 pl-1">
                    <label><span class="text-danger font-weight-bold">*</span> เขต/อำเภอ</label>
                    <b-form-select v-model="form.district_id" @change="changeDistrict(form.district_id)" :options="sortedDistricts" value-field="id" text-field="name_th" required></b-form-select>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label><span class="text-danger font-weight-bold">*</span> คุณแม่บ้านค้นหางานจากช่องทางใด</label>
                <b-form-checkbox-group
                  id="checkbox-group-2"
                  v-model="form.media_channel"
                  name="flavour-2"
                  stacked
                >
                  <b-form-checkbox class="mb-3" value="Finnix">แอปฟินนิกซ์ (FINNIX) - มีโค้ดส่วนลด</b-form-checkbox>
                    <b-form-group v-if="form.media_channel.find((e) =>  e == 'Finnix')">
                      <label>กรอกโค้ดส่วนลด</label>
                      <b-form-input v-model="form.media_channel_detail"></b-form-input>
                  </b-form-group>
                  <b-form-checkbox class="my-3" value="google">ค้นหาใน Google</b-form-checkbox>
                  <b-form-checkbox class="my-3" value="Facebook">ค้นหาใน Facebook</b-form-checkbox>
                  <b-form-checkbox class="mt-3" value="Youtube">ค้นหาใน Youtube</b-form-checkbox>
                  <b-form-checkbox class="mt-3" value="Tiktok">ค้นหาใน Tiktok</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>  
              <hr>
              <p>จังหวัดที่เปิดรับสมัคร : กรุงเทพฯ, นนทบุรี, ปทุมธานี, สมุทรปราการ, นครปฐม, สมุทรสาคร, เชียงใหม่, ชลบุรี</p>
              <b-form-group>
                <b-form-checkbox
                  class="mt-3 mb-4"
                  id="checkbox-accepted"
                  v-model="form.accepted_pdpa"
                  name="checkbox-accepted"
                  value="1"
                  unchecked-value="0"
                >
                  ยอมรับเงื่อนไขนโยบายคุ้มครองข้อมูลส่วนบุคคลและยินยอมให้เปิดเผย
                  ข้อมูลส่วนบุคคล <a target="_blank" download href="/static/pdf/เอกสารแสดงความยินยอมให้เปิดเผยข้อมูลส่วนบุคคล_beneat.pdf">ดูเพิ่มเติม</a>
                </b-form-checkbox>
              </b-form-group>
            </template>
            <template v-else-if="step == 2">
              <div class="text-center">
                <h2 style="color: red;">รหัสผู้สมัคร : BN{{ agencyProfessional ? codeAgency : '' }}
                  <br>
  
                  <button v-if="agencyProfessional"
                          class="h5 btn btn-outline-secondary mt-3"
                          type="button"
                           v-clipboard:copy="'BN'+codeAgency" @click.prevent="copiedCode('BN'+codeAgency)" style="cursor: pointer;">
                    <i class="fa fa-clone mb-1">คัดลอกรหัส</i>
                  </button>
                </h2>
  
  
                <h5>กรุณานำรหัสผู้สมัครที่ได้รับ แจ้งกลับในไลน์</h5>
                <!-- <h5>เพื่อลุ้นรับสิทธิพิเศษ ค่าอบรม ค่าสมัคร ค่าตรวจประวัติอาชญากรรม ฟรี !!</h5> -->
              </div>
  
              <div class="text-center mt-5" v-if="abTest == 'ATest'">
                <a href="https://lin.ee/R8qgKjG" target="_blank">
                  <b-img-lazy style="height: 100px;" src="/static/img/professional/semAgency/photo_click_add_line.jpeg" :class="$mq.phone ? 'img-fluid' : ''"></b-img-lazy>
                </a>
              </div>
  
              <div class="row mt-3">
                <div class="col-12 col-md-6">
                  <div>
                    <b-img-lazy src="https://beneat.s3.ap-southeast-1.amazonaws.com/marketing_campaigns/agency-professional-register-promotion.png" :class="$mq.phone ? 'img-fluid' : 'img-default-size'" alt=""></b-img-lazy>
                  </div>
                </div>
                <div class="col-12 col-md-6" v-if="abTest == 'ATest'">
                  <a href="https://lin.ee/R8qgKjG" target="_blank" @click="step = 1">
                    <b-img-lazy src="/static/img/professional/semAgency/photo_add_line.jpeg" :class="$mq.phone ? 'img-fluid' : 'img-default-size'"></b-img-lazy>
                  </a>
                </div>
              </div>
  
  
              <div class="text-center mt-3" v-if="abTest == 'BTest'">
                <div>
                  <a class="btn" style="text-decoration: underline;">ถ้ายังไม่ได้แอดไลน์</a>
                </div>
                <a href="https://lin.ee/R8qgKjG" target="_blank" @click="step = 1">
                  <b-img-lazy style="height: 100px;" src="/static/img/professional/semAgency/photo_click_add_line.jpeg" :class="$mq.phone ? 'img-fluid' : ''"></b-img-lazy>
                </a>
              </div>
  
              <br>
            </template>
            <template v-else-if="step == 3">
              <div class="text-center">
                <h5>ลุ้นรับสิทธิพิเศษ ค่าอบรม ค่าสมัคร ค่าตรวจประวัติอาชญากรรม ฟรี !!</h5>
              </div>
              <div class="text-center mt-5">
                <a href="https://lin.ee/R8qgKjG" target="_blank" @click="step = 1">
                  <b-img-lazy style="height: 100px;" src="/static/img/professional/semAgency/photo_click_add_line.jpeg" :class="$mq.phone ? 'img-fluid' : ''"></b-img-lazy>
                </a>
                <div>
                  <a class="btn text-primary" style="text-decoration: underline;" @click="AddedLine">แอดไลน์แล้ว กดที่นี่</a>
                </div>
              </div>
  
              <div class="row mt-3">
                <div class="col-12 col-md-6">
                  <div>
                    <b-img-lazy src="https://beneat.s3.ap-southeast-1.amazonaws.com/marketing_campaigns/agency-professional-register-promotion.png" :class="$mq.phone ? 'img-fluid' : 'img-default-size'" alt=""></b-img-lazy>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <a href="https://lin.ee/R8qgKjG" target="_blank">
                    <b-img-lazy src="/static/img/professional/semAgency/photo_add_line.jpeg" :class="$mq.phone ? 'img-fluid' : 'img-default-size'"></b-img-lazy>
                  </a>
                </div>
              </div>
  
              <br>
            </template>
  
  
            <template v-if="step == 1">
              <b-button class="button-block mt-3" :disabled="!(form.full_name && form.phone && form.accepted_pdpa == '1' && nameState == true)" type="submit" variant="info">ส่งข้อมูล</b-button>
            </template>
          </b-form>
  
        </div>
      </div>
      <section id="floating-icon-contacts" :class="form.isHiddenChatButton">
        <div class="fab-container"
             ref="fab-agency-floating-button"
             @mousemove="onMouseMoveFloatingButton($event)"
             @mouseleave="onMouseLeaveFloatingButton($event)"
             @click="onClickFloatingButton($event)"
        >
          <div class="fab shadow">
            <div class="fab-content">
              <span class="material-icons">
                <transition name="mode-fade" mode="out-in">
                  <div v-if="!form.isActiveInMobile">
                    <img src="/static/img/floatingButton/call_center_crop_head.png" width="80"
                         class="img-fluid rounded-circle" alt="" id="img-call-center-crop">
                  </div>
                  <div v-else class="circle-close-rotate">
                   <span class="icon-cross"></span>
                   <span class="visually-hidden">Close</span>
                  </div>
                </transition>
              </span>
            </div>
          </div>
          <div class="sub-button shadow">
            <a href="tel:02-113-1138" target="_blank">
              <span class="item-icons">
                <img src="/static/img/floatingButton/telephone-call.png" data-platform="telephone" class="img-fluid rounded-circle" width="80">
              </span>
            </a>
          </div>
          <div class="sub-button shadow">
            <a href="https://lin.ee/sA89db3" target="_blank">
              <span class="item-icons">
                 <img src="/static/img/floatingButton/line.png" data-platform="line" class="img-fluid rounded-circle" width="80">
              </span>
            </a>
          </div>
          <div class="sub-button shadow">
            <a href="https://www.m.me/BeNeatCleaner" target="_blank">
              <span class="item-icons">
                <img src="/static/img/floatingButton/messenger.png" data-platform="messenger" class="img-fluid rounded-circle" width="80">
              </span>
            </a>
          </div>
        </div>
      </section>
    </div>
    <section v-if="step == 1">
      <section>
        <div class="section-apply-professionals">
          <div class="row">
            <div class="col-md-10 offset-md-1">
              <h2 class="text-center">{{ $t('message.apply.what_is_beneat_title') }}</h2>
              <p class="text-left">{{ $t('message.apply.what_is_beneat_detail') }}</p>
              <p class="text-left">
                เราเป็นบริษัท Startup ที่ได้รับการสนับสนุน จากกระทรวงวิทยศาสตร์และเทคโนโลยี เพื่อการพัฒนาระบบการรับงานทำความสะอาดแบบพาร์ทไทม์ ผ่านเทคโนโลยี Application เพื่อให้คุณแม่บ้าน สามารถทำงานพาร์ทไทม์ได้ อย่างสะดวก รวดเร็ว และ ปลอดภัย ในยุคไทยแลนด์ 4.0
              </p>
              <div class="row">
                <div class="col-md-6 ">
                  <img src="/static/img/apply-news01.jpg" alt="ภาพบรรยากาศการทำงานของแม่บ้าน BeNeat" class="img-fluid">
                </div>
                <div class="col-md-6 col-md-6 mt-2 mt-md-0">
                  <img src="/static/img/apply-news02.jpg" alt="" class="img-fluid">
                </div>
              </div>
    
              <p class="mt-3 text-left">
                ท่านรัฐมนตรีว่าการกระทรวงวิทยาศาตร์และเทคโนโลยี (ดร.สุวิทย์ เมษินทรีย์) เข้าเยี่ยมเยือนบริษัท และ ให้กำลังใจคุณแม่บ้าน
              </p>
              <p class="mt-3 text-left" v-html="$t('message.apply.sub_title')"></p>
              <div class="embed-responsive embed-responsive-16by9">
                <iframe width="560"
                        height="315"
                        src="https://www.youtube.com/embed/YaHw1mGL_kk"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen></iframe>
              </div>
              <div class="embed-responsive embed-responsive-16by9 mt-5">
                <iframe width="560"
                        height="315"
                        src="https://www.youtube.com/embed/tQw3LCKszs8"
                        frameborder="0"
                        allow="autoplay; encrypted-media"
                        allowfullscreen></iframe>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="mt-4 text-left">
                BeNeat Academy คือ ศูนย์ฝึกอบรมคุณแม่บ้านที่มีมาตรฐาน โดย คุณแม่บ้านทุกท่านในระบบ จะได้รับการฝึกสอนทั้งทาง ทฤษฎี และ ปฎิบัติโดยผู้เชี่ยวชาญของบีนีท ซึ่งเป็นหลักสูตรที่บีนีทมีการออกแบบมาอย่างดี และ เป็นลิขสิทธิ์เฉพาะ ของบีนีท
              </div>
              <div class="mt-4 text-left">
                ในศูนย์ฝึกอบรมจะประกอบด้วย สิ่งอำนวยความสะดวกทันสมัยต่างๆ ที่จำลองมาจากสภาพหน้างานจริงๆ ไม่ว่าจะเป็นห้องพักลักษณะ บ้าน, condo , สำนักงาน และ โรงแรม ซึ่งคุณแม่บ้านจะได้รับการฝึกฝนให้สามารถรับมือกับ ลักษณะงานที่หลากหลายเกือบทุกประเภท และสร้างความมั่นใจให้กับคุณแม่บ้านก่อนเข้าไปทำงานจริง
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="content-padding">
        <div class="row">
          <div class="col-12">
            <h2 class="text-center">{{ $t('message.apply.why_work_with_beneat') }}</h2>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-3 col-md-3 text-center">
            <img src="/static/img/wallet.svg" width="60">
            <h3 class="mt-3">รายได้ดี</h3>
            <p>ผู้ให้บริการในระบบส่วนใหญ๋ได้รับรายได้เฉลี่ยเดือนละ 20,000-40,000 บาท (ขึ้นอยู่กับความขยันและความตั้งใจทำงาน)</p>
          </div>
          <div class="col-sm-3 col-md-3 text-center">
            <i class="fal fa-clock" style="font-size: 60px; color: #1FBCD2;"></i>
            <h3 class="mt-3">{{ $t('message.apply.why_benefit_title01') }}</h3>
            <p>{{ $t('message.apply.why_benefit_detail01') }}</p>
          </div>
          <div class="col-sm-3 col-md-3 text-center">
            <img src="/static/img/protect.svg" width="60">
            <h3 class="mt-3">{{ $t('message.apply.why_benefit_title02') }}</h3>
            <p>{{ $t('message.apply.why_benefit_detail02') }}</p>
          </div>
          <div class="col-sm-3 col-md-3 text-center">
            <img src="/static/img/community.svg" width="60">
            <h3 class="mt-3">{{ $t('message.apply.why_benefit_title03') }}</h3>
            <p>{{ $t('message.apply.why_benefit_detail03') }}</p>
          </div>
        </div>
      </section>
      <section class="section-apply-professionals">
        <div class="row">
          <h2>{{ $t('message.apply.requirements') }}</h2>
            <ul class="maininfo-list text-left">
              <li>{{ $t('message.apply.requirements01') }}</li>
              <li>{{ $t('message.apply.requirements02') }}</li>
              <li>{{ $t('message.apply.requirements03') }}</li>
              <li>{{ $t('message.apply.requirements04') }}</li>
              <li>{{ $t('message.apply.requirements05') }}</li>
            </ul>
        </div>
        <div class="row mt-3">
          <div class="col-12"><h4>สมัครผู้ให้บริการ</h4></div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="card">
              <div class="card-body text-center">
                <button class="btn btn-warning btn-block" @click="focusInput">
                  {{ $t('message.apply.register') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col-12">
            <h4>{{ $t('message.apply.contact_data00') }}</h4>
            <h4>{{ $t('message.apply.contact_data01') }}</h4>
            <h4>{{ $t('message.apply.contact_data03') }}</h4>
          </div>
        </div>
    
      </section>
    </section>
  </main>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'

export default {
  data: () => ({
    form: {
      full_name: null,
      phone: null,
      accepted_pdpa: '0',
      age: '',
      address: '',
      address_province_id: '',
      district_id: '',
      sub_district_id: '',
      job_interests: [],
      job_interests_other: '',
      have_vehicle: '',
      vehicle_remark: '',
      job_available_time: [],
      job_available_time_other: '',
      media_channel: [],
      isActiveInMobile: false,
      media_channel_detail: '',
      email: null
    },
    agencyProfessional: null,
    step: 1,
    abTest: 'ATest'
  }),
  metaInfo () {
    return {
      title: 'คุณแม่บ้าน BeNeat - สมัครแม่บ้านออนไลน์ รายได้ 4,000-7,000 บาท/สัปดาห์ สมัครง่าย รายได้ดี มีโบนัส จ่ายเงินตรงเวลา เลือกเวลาทำงานได้',
      link: [
        {
          rel: 'canonical',
          href: 'https://beneat.co/agency-professional-register'
        }
      ],
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: 'BeNeat คุณแม่บ้านออนไลน์ - สมัครงานแม่บ้านออนไลน์ง่ายๆ งานอิสระ รายได้ดี 4,000-7,000 บาท/สัปดาห์ ไม่ต้องหาลูกค้าเอง รับเงินตรงเวลาทุกสัปดาห์ เลือกวัน-เวลาทำงานได้ สมัครง่ายในไม่กี่ขั้นตอน มีทีมงานดูแล สมัครเลย!'
        },
        {
          vmid: 'keywords',
          name: 'keywords',
          content: 'งานแม่บ้าน,สมัครงานแม่บ้าน,งานพาร์ทไทม์,งานทำความสะอาด,แม่บ้านรายวัน,BeNeat,บีนีท'
        },
        {
          vmid: 'image',
          name: 'image',
          content: 'https://beneat.co/static/img/apply-news01.jpg'
        },
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'คุณแม่บ้าน BeNeat - สมัครแม่บ้านออนไลน์ รายได้ 4,000-7,000 บาท/สัปดาห์ สมัครง่าย รายได้ดี มีโบนัส จ่ายเงินตรงเวลา เลือกเวลาทำงานได้'
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: 'BeNeat คุณแม่บ้านออนไลน์ - สมัครงานแม่บ้านออนไลน์ง่ายๆ งานอิสระ รายได้ดี 4,000-7,000 บาท/สัปดาห์ ไม่ต้องหาลูกค้าเอง รับเงินตรงเวลาทุกสัปดาห์ เลือกวัน-เวลาทำงานได้ สมัครง่ายในไม่กี่ขั้นตอน มีทีมงานดูแล สมัครเลย!'
        },
        {
          vmid: 'og:image',
          name: 'og:image',
          content: 'https://beneat.co/static/img/apply-news01.jpg'
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: this.url
        },
        {
          vmid: 'og:type',
          property: 'og:type',
          content: 'website'
        },
        {
          vmid: 'og:locale',
          property: 'og:locale',
          content: 'th_TH'
        },
        {
          vmid: 'twitter:card',
          name: 'twitter:card',
          content: 'summary_large_image'
        },
        {
          vmid: 'twitter:title',
          name: 'twitter:title',
          content: 'คุณแม่บ้าน BeNeat - สมัครแม่บ้านออนไลน์ รายได้ 4,000-7,000 บาท/สัปดาห์ สมัครง่าย รายได้ดี มีโบนัส จ่ายเงินตรงเวลา เลือกเวลาทำงานได้'
        },
        {
          vmid: 'twitter:description',
          name: 'twitter:description',
          content: 'BeNeat คุณแม่บ้านออนไลน์ - สมัครงานแม่บ้านออนไลน์ง่ายๆ งานอิสระ รายได้ดี 4,000-7,000 บาท/สัปดาห์ ไม่ต้องหาลูกค้าเอง รับเงินตรงเวลาทุกสัปดาห์ เลือกวัน-เวลาทำงานได้ สมัครง่ายในไม่กี่ขั้นตอน มีทีมงานดูแล สมัครเลย!'
        },
        {
          vmid: 'twitter:image',
          name: 'twitter:image',
          content: 'https://beneat.co/static/img/apply-news01.jpg'
        }
      ]
    }
  },
  computed: {
    ...mapState('addressProvince', [
      'addressProvinces',
      'districts',
      'subDistricts',
      'document_provinces',
      'document_districts',
      'document_subDistricts'
    ]),
    sortedProvinces () {
      return this._.orderBy(this.addressProvinces, ['name_th'], ['asc'])
    },
    sortedDistricts () {
      return this._.orderBy(this.districts, ['name_th'], ['asc'])
    },
    sortedSubDistricts () {
      return this._.orderBy(this.subDistricts, ['name_th'], ['asc'])
    },
    nameState () {
      let state = null
      const rex = /^\+?[0-9-]+$/
      let phone = this.form.phone
      if (phone) {
        let valid = phone.match(rex)
        if (!valid) {
          state = false
        } else {
          state = false
          if (phone.length >= 10 && phone.length <= 15) {
            let phoneValid = phone.match(rex)
            if (phoneValid) {
              state = true
            }
          }
        }
      }
      return state
    },
    codeAgency () {
      if (this.agencyProfessional) {
        return this.agencyProfessional.id.toString().padStart(4, '0')
      }
      return ''
    }
  },
  methods: {
    copiedCode (code) {
      this.$swal({
        title: code,
        text: 'คัดลอกรหัสสำเร็จ',
        type: 'success',
        timer: 800,
        showConfirmButton: false
      })
    },
    acceptNumber (data) {
      this.form.phone = ''
      const rex = /^\+?[0-9-]+$/
      if (data.length >= 10 && data.length <= 15) {
        let valid = data.match(rex)
        if (valid) {
          this.form.phone = valid.input
        }
      }
    },
    checkJobAvailableTimeOther (data) {
      if (!data) return false
      for (let j = 0; j < data.length; j++) {
        if (data[j] === 'อื่นๆ') {
          return true
        }
      }
      return false
    },
    next (step) {
      if (step === this.step) {
        this.step++
      }
    },
    onSubmit () {
      this.$validator.validateAll('form-register-byagen').then(async (valid) => {
        if (valid) {
          try {
            const { data } = await axios.post('/agency-professional-register', this.form)
            if (!data.error) {
              this.agencyProfessional = { ...data.agency_professional }
              this.$swal({
                type: 'success',
                text: 'ส่งข้อมูลสำเร็จ'
              })
              this.step++
            }
          } catch (err) {
            const responseData = err.response.data
            if (responseData.validator) {
              const message = err.response ? err.response.data.message : err.message
              this.$swal({ text: message, type: 'error' })
            } else {
              this.$swal({ text: 'ขออภัยค่ะ เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง หรือ ติดต่อเจ้าหน้าที่', type: 'error' })
            }
          }
        }
      })
    },
    fetchAddressProvinces () {
      const queryData = {
        is_all: 1
      }
      this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES', queryData)
    },
    fetchDistricts (provinceId) {
      if (provinceId) {
        const queryData = {
          province_id: provinceId
        }
        this.$store.dispatch('addressProvince/LOAD_DISTRICTS', queryData)
      }
    },
    fetchSubDistricts (districtId) {
      if (districtId) {
        const queryData = {
          district_id: districtId
        }
        this.$store.dispatch('addressProvince/LOAD_SUB_DISTRICTS', queryData)
      }
    },
    changeAddressProvince (id) {
      this.fetchDistricts(id)
      this.form.district_id = null
      this.form.sub_district_id = null
    },
    changeDistrict (id) {
      this.fetchSubDistricts(id)
      this.form.sub_district_id = null
    },
    onClickFloatingButton () {
      if (this.$mq.phone) {
        const elementButton = this.$refs['fab-agency-floating-button']
        if (!elementButton.classList.contains('fab-container-button-hover')) {
          this.isActiveInMobile = true
          elementButton.classList.add('fab-container-button-hover')
        } else {
          this.isActiveInMobile = false
          elementButton.classList.remove('fab-container-button-hover')
        }
      }
    },
    onMouseLeaveFloatingButton (event) {
      const elementButton = this.$refs['fab-agency-floating-button']
      if (elementButton.classList.contains('fab-container-button-hover')) {
        elementButton.classList.remove('fab-container-button-hover')
        this.isActiveInMobile = false
      }
    },
    onMouseMoveFloatingButton (event) {
      // only desktop will active mouse move
      if (!this.$mq.phone) {
        const elementButton = this.$refs['fab-agency-floating-button']
        if (!elementButton.classList.contains('fab-container-button-hover')) {
          elementButton.classList.add('fab-container-button-hover')
        }
      }
    },
    AddedLine () {
      this.step = 1
    },
    focusInput () {
      this.$refs.formInput.scrollIntoView({ behavior: 'smooth' })
    }
  },
  created () {
    this.fetchAddressProvinces()
    const abTestMappings = {
      'add-line': { step: 3, abTest: 'BTest' },
      'form': { step: 1, abTest: 'ATest' }
    }

    const abTestValue = this.$route.query && this.$route.query.content_type ? this.$route.query.content_type : 'form'
    const mapping = abTestMappings[abTestValue]

    if (mapping) {
      this.step = mapping.step
      this.abTest = mapping.abTest
    }
  }
}
</script>
<style scoped>
.img-phone-size {
  width: 330px;
}

.img-default-size {
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/agencyProfessionalRegister/index.vue